<template>
  <div>
    <template v-if="type == 'BUSSTOP'">
      <docomo-busstop-marker />
    </template>
    <template v-else-if="type == 'POSITION'">
      <docomo-position-marker />
    </template>
    <docomo-car-marker />
    <docomo-current-marker />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DocomoBusstopMarker from './DocomoBusstopMarker'
import DocomoPositionMarker from './DocomoPositionMarker'
import DocomoCarMarker from './DocomoCarMarker'
import DocomoCurrentMarker from './DocomoCurrentMarker'

export default {
  components: {
    DocomoBusstopMarker,
    DocomoPositionMarker,
    DocomoCarMarker,
    DocomoCurrentMarker
  },
  computed: {
    ...mapGetters({
      type: 'reservation/getType'
    })
  }
}
</script>
